import {post,get} from '@/libs/ajax.js'

/**
 * 智能预警详情
 * @param {*} data 
 * @returns 
 */
export function getIntelligentForewarnApi (data) {
    return get('/apple_promotion_manage/get_intelligent_forewarn', data)
}
/**
 * 删除预警
 * @param {*} data 
 * @returns 
 */
export function deleteIntelligentForewarnApi (data) {
    return get('/apple_promotion_manage/delete', data)
}
/**
 * 编辑预警
 * @param {*} data 
 * @returns 
 */
export function editIntelligentForewarnApi (data) {
    return post('/apple_promotion_manage/edit_intelligent_forewarn', data)
}
/**
 * 保存预警
 * @param {*} data 
 * @returns 
 */
export function saveIntelligentForewarnApi (data) {
    return post('/apple_promotion_manage/save_intelligent_forewarn', data)
}